module.exports = __webpack_public_path__ + "static/Thri_Kreen-43512f64e595b84cfacedb6b4f28f1dd.jpg";